import { useDataValue } from 'Simple/Data.js'

export function useDisabled(props) {
  let sources = useDataValue({
    viewPath: props.viewPath,
    context: 'dwt',
    path: 'sources',
  })
  let isAcquiring = useDataValue({
    viewPath: props.viewPath,
    context: 'dwt',
    path: 'isAcquiring',
  })
  let isUploading = useDataValue({
    viewPath: props.viewPath,
    context: 'dwt',
    path: 'isUploading',
  })
  return sources.length === 0 || isAcquiring || isUploading
}
